import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';

export const shapesServiceApi = createApi({
  reducerPath: 'shapesServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getShapes: builder.query<any, any>({
      query: (id) => ({ url: `agency/lines/${id}/shape?${id}`, mode: 'no-cors' }),
    }),
  }),
});

export const { useLazyGetShapesQuery } = shapesServiceApi;
